<template>
  <div>
    <el-dialog
      ref="addEditDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="add_view_edit_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogAddEditForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="付款单位">
                    <el-input
                      v-model="dialogAddEditForm.paymentUnitName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="收款单位">
                    <el-input
                      v-model="dialogAddEditForm.receiveUnitName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收款银行">
                    <el-input
                      v-model="dialogAddEditForm.receiveBankName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收款账号">
                    <el-input
                      v-model="dialogAddEditForm.receiveBankNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="收款日期"
                    prop="receiveDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditForm.receiveDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="凭证号"
                    prop="voucherNo"
                  >
                    <el-input
                      v-model="dialogAddEditForm.voucherNo"
                      maxlength="32"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="实际收款金额">
                    <el-input
                      v-model="mathReceivedTotal"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="差异金额"
                    required
                  >
                    <el-input
                      v-model="dialogAddEditForm.differenceAmount"
                      @input="(val)=>{limitNumber(val, dialogAddEditForm, 'differenceAmount')}"
                      @blur="setNumberValueDefaultZero($event, dialogAddEditForm, 'differenceAmount', 2);"
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              明细信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="dialogAddEditForm.receiveDetailData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                      align="center"
                    />
                    <el-table-column
                      label="项目编号"
                      prop="projectNo"
                      width="160"
                      show-overflow-tooltip
                      header-align="center"
                    />
                    <el-table-column
                      label="项目名称"
                      prop="projectName"
                      header-align="center"
                    />
                    <el-table-column
                      label="季度"
                      prop="quarter"
                      width="80"
                      align="center"
                    />
                    <el-table-column
                      label="应收金额"
                      prop="totalAmount"
                      width="100"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.totalAmount) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="未收金额"
                      prop="leftAmount"
                      width="100"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ formatNumberThousandSeparator(scope.row.leftAmount) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="收款金额"
                      width="150"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <el-form-item
                          :prop="'receiveDetailData.' + scope.$index + '.amount'"
                          :rules="dialogAddEditFormRules.amount"
                        >
                          <el-input
                            v-model="scope.row.amount"
                            @input="(val)=>{limitPositiveNumber(val, scope.row, 'amount')}"
                            @blur="setNumberValueDefaultZero($event, scope.row, 'amount', 2);"
                          />
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box pic-container">
            <h3 class="modal-title">
              附件信息
            </h3>
            <div class="modal-row-box">
              <el-upload
                ref="picUpload"
                list-type="picture-card"
                :action="picUploadAction"
                :data="picData"
                :before-upload="beforeAvatarUpload"
                :file-list="initFileList"
                :on-preview="handlePictureCardPreview"
                :headers="{'X-Token': getToken()}"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
                :with-credentials="true"
                :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picList)}"
                :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picList)"
              >
                <el-button
                  type="success"
                  style="margin-top:1px; margin-right:15px;"
                  class="upload-button"
                  icon="el-icon-folder-opened"
                >
                  选择图片
                </el-button>
              </el-upload>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditForm.remark"
                      type="textarea"
                      placeholder="备注"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          :disabled="operateButtonDisable"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
      <!--图片预览-->
      <el-dialog
        :visible.sync="dialogImageVisible"
        append-to-body
      >
        <img
          width="100%"
          :src="dialogImageUrl"
          alt=""
        >
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 数据请求
import { getToken } from "@/utils/auth"
import { initReceiveVoucherApi, saveOrUpdateReceiveVoucherApi } from '@/api/receiveVoucher'
// 附件
import { deleteFileApi } from '@/api/common'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    },
    dataArray: {
      type: Array,
      default: () => []
    }
  },
  data() {
    // 收款金额
    const validatePaidAmount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入收款金额'))
      } else if (Number(value) === 0) {
        callback(new Error('收款金额不能为0'))
      } else {
        callback()
      }
    }
    return {
      loading: true,
      loadingText: '努力加载数据中，请耐心等待',
      operateButtonDisable: false,

      dialogAddEditForm: {
        receiveDetailData: []
      },
      dialogAddEditFormRules: {
        receiveDate: [{ required: true, message: '请选择收款日期', trigger: 'blur' }],
        voucherNo: [{ required: true, message: '请输入凭证号', trigger: 'blur' }, { max: 32, message: '最多输入32个字符', trigger: 'blur' }],
        amount: [{ required: true, validator: validatePaidAmount, trigger: ['blur', 'change'] }],
        remark: [{ max: 128, message: '最多输入256个字符', trigger: 'blur' }]
      },
      //附件相关
      picData: { directory: 'receiveVoucher' },
      picUploadAction: '',
      initFileList: [],
      dialogImageUrl: '',
      dialogImageVisible: false,
      picList: [], // 照片对象数组
      baseUrl: ''
    }
  },
  computed: {
    // 计算收款总金额
    mathReceivedTotal() {
      let total = this.dialogAddEditForm.receiveDetailData.reduce((prev, item) => {
        return this.formatNumber(prev + Number(item.amount), 2)
      }, 0)
      return this.formatNumber(Number(this.dialogAddEditForm.differenceAmount) + total, 2)
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.loading = true
        this.operateButtonDisable = false
        this.loadingText = '努力加载数据中，请耐心等待'

        this.dialogAddEditForm = {
          provinceId: 0,
          provinceName: '',
          cityId: 0,
          cityName: '',
          paymentUnitId: 0,
          paymentUnitName: '',
          receiveUnitId: 0,
          receiveUnitName: '',
          receiveBankName: '',
          receiveBankNo: '',
          receiveDate: '',
          voucherNo: '',
          receiveAmount: 0,
          differenceAmount: 0,
          remark: '',
          receiveDetailDataJson: '',
          receiveDetailData: []
        }
        //附件相关
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.picUploadAction = process.env.VUE_APP_BASE_API + '/web/common/uploadFile'
        this.picList = []
        this.initFileList = []

        if (this.eventType === 'edit') {
          this.initEditData()
        } else {
          this.initAddData()
        }

        this.$nextTick(() => {
          this.$refs.dialogAddEditForm.clearValidate()
        })
      }
    }
  },
  methods: {
    getToken,
    //新增
    initAddData() {
      this.dataArray.forEach(item => {
        if (this.dialogAddEditForm.provinceId === 0) {
          this.dialogAddEditForm.provinceId = item.provinceId
          this.dialogAddEditForm.provinceName = item.provinceName
          this.dialogAddEditForm.cityId = item.cityId
          this.dialogAddEditForm.cityName = item.cityName
          this.dialogAddEditForm.paymentUnitId = item.paymentUnitId
          this.dialogAddEditForm.paymentUnitName = item.paymentUnitName
          this.dialogAddEditForm.receiveUnitId = item.receiveUnitId
          this.dialogAddEditForm.receiveUnitName = item.receiveUnitName
          this.dialogAddEditForm.receiveBankName = item.receiveBankName
          this.dialogAddEditForm.receiveBankNo = item.receiveBankNo
        }

        this.dialogAddEditForm.receiveDetailData.push({
          receivableId: item.id,
          projectNo: item.projectNo,
          projectName: item.projectName,
          quarter: item.quarter,
          totalAmount: item.totalAmount,
          leftAmount: item.leftAmount,
          amount: 0
        })
      })
      this.loading = false
    },
    // 加载数据
    initEditData() {
      initReceiveVoucherApi({ id: this.dataId }).then(res => {
        const { receiveVoucher, receivableReceives, fileList } = res.data

        for (let key in this.dialogAddEditForm) {
          if (!receiveVoucher[key]) continue
          this.dialogAddEditForm[key] = receiveVoucher[key]
        }

        this.dialogAddEditForm.receiveDate = receiveVoucher.receiveDateValue
        this.dialogAddEditForm.id = receiveVoucher.id
        if (receivableReceives) {
          this.dialogAddEditForm.receiveDetailData = []
          receivableReceives.forEach(item => {
            item.leftAmount = Number((Number(item.leftAmount) + Number(item.amount)).toFixed(2))
            this.dialogAddEditForm.receiveDetailData.push(item)
          })
        }

        //附件相关
        if (fileList.length > 0) {
          fileList.forEach(item => {
            let obj = {
              name: item.attachmentName, url: this.baseUrl + item.attachmentUrl, attachmentName: item.attachmentName, attachmentUrl: item.attachmentUrl
            }
            this.picList.push(obj)
            this.initFileList.push(obj)
          })
        }
        this.loading = false
      })
    },
    //上传前
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 20
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过20MB!')
        return false
      }
      this.isUploading = true
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    // 上传成功
    handleSuccess(res, file, fileList, dataObj) {
      if (res.mark === '200') {
        let fileObj = {}
        fileObj.attachmentName = res.myFileName
        fileObj.attachmentUrl = res.fileName
        fileObj.url = this.baseUrl + res.fileName
        dataObj.push(fileObj)
        this.isUploading = false
      } else {
        this.$message.error(res.message)
      }
    },
    // 删除
    handlePictureCardRemove(file, fileList, dataObj) {
      let fileUrl = ''
      if (file.response) {
        let resData = file.response
        let delIndex = dataObj.findIndex(item => {
          return item.attachmentUrl === resData.fileName
        })
        fileUrl = resData.fileName
        dataObj.splice(delIndex, 1)
      } else {
        let delIndex = dataObj.findIndex(item => {
          if (item.url === file.url) {
            fileUrl = item.attachmentUrl
            return item.url === file.url
          }
        })
        dataObj.splice(delIndex, 1)
      }
      if (fileUrl !== '') {
        deleteFileApi({ filePath: fileUrl }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
          }
        })
      }
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    // 关闭弹框
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.dialogAddEditForm.receiveDetailData.forEach(item => {
        if (Number(item.amount) > Number(item.leftAmount)) {
          this.$message({ message: '项目(' + item.projectName + ')收款金额大于未收款金额，不能保存', type: 'warning' })
          return false
        }
      })
      this.$refs.dialogAddEditForm.validate(valid => {
        if (String(this.mathReceivedTotal) === 'NaN') {
          this.$message({ message: '录入金额异常，不能保存', type: 'warning' })
          return false
        }
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '收款单', '系统提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            this.loading = true
            this.loadingText = '正在努力保存数据中'
            this.operateButtonDisable = true

            this.dialogAddEditForm.receiveAmount = Number(this.mathReceivedTotal)
            this.dialogAddEditForm.receiveDetailDataJson = JSON.stringify(this.dialogAddEditForm.receiveDetailData)

            //附件相关
            let picUrls = []
            let picNames = []
            this.picList.forEach(item => {
              picUrls.push(item.attachmentUrl)
              picNames.push(item.attachmentName)
            })
            this.dialogAddEditForm.picUrls = JSON.stringify(picUrls)
            this.dialogAddEditForm.picNames = JSON.stringify(picNames)
            saveOrUpdateReceiveVoucherApi(this.dialogAddEditForm).then(res => {
              if (res.mark === '200') {
                this.$message({ message: res.message, type: 'success' })
                this.reloadData()
                this.modalClose()
              }
            }).catch(() => {
              this.loading = false
              this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
::v-deep .special-row .el-col {
  min-height: 20px;
}
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 0px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}
::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}
.demo-input-suffix {
  padding: 10px 0;
  .el-input {
    margin-right: 10px;
    width: 120px;
  }
  .title-sp {
    color: #1a9bff;
    margin-right: 10px;
  }
}
</style>
